<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box invest-with-us">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<h1>Thank you!</h1>
							<br />
							<button @click="this.window.location.href='/'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 230px; border-radius: 26.5px; border: none;">Go back to home page</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Try us now. See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/contact-us">Contact Us <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="american-credit-thank-you-img" src="../assets/imgs/American_Credit_Equipment_Financing_and_Invoice_Factoring_thank_You.png" alt="American Credit Equipment Financing and Invoice Factoring thank You"/>
					</div>
				</div>
        <div class="col-lg-10 offset-lg-1" style="border-bottom: 1px solid #dcdcdc;"></div>
			</div>
		</div>


    <!-- <div style="width: 100%; background: #053a7a;">
      <div class="container bluebg text-center">
        <div class="contexbox text-center">
          <br />
          <br />
          <h1 class="text-white font-weight-bold">Thank You</h1>
          <br />
          <h4>We will be in touch shortly</h4>
          <br />
          <h1 class="darkbluefont font-weight-bold"><a href="tel:855-904-0188">855-904-0188</a></h1>
          <br />
          <br />
        </div>
      </div>
    </div> -->

    <div style="width: 100%; background: white;">
      <div class="container platform trust-us">
        <div class="row trust-us-box">
          <div class="col-12 col-lg-5 offset-lg-1 trust-us-inner-left">
            <div>
              <h1 class="trust-us-title">American Credit: the difference you can trust</h1>
              <p class="trust-us-text" style="color: #686868; font-weight: 300;"><span style="font-weight: 700;">You work hard. We work hard. We share the same ethic.</span> That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.</p>
              <br />
              <div class="trust-us-button">
                <button @click="this.window.location.href='/get-start'">Apply Now</button>
                <p><span style="color: #3c3c3c; font-weight: 700;"><a href="/contact-us">Feel free to contact us <i class="fa fa-long-arrow-right" style="color: #5456ff;"></i></a></span></p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 trust-us-inner-right">
            <img src="../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png" alt="American Credit Business loans the Difference You can Trust"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../vuex/types";
import _ from "lodash";
import api from "../vuex/api/index";

export default {
  data() {
    return {
      rules: {},
      isLoading: false,

      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      var _this = this;
      api
        .postForm("/common/sysfeedback/mgxyContact.ht", {
          tokenId: _this.userInfo.token,
          lastName: _this.step2Form.lastName,
          firstName: _this.step2Form.firstName,
          email: _this.step2Form.email,
          phone: _this.step2Form.phone,
          content: _this.step2Form.content
        })
        .then(res => {
          this.isLoading = false;
          this.$router.push({
            path: `/`,
            query: {}
          });
        });
    }
  }, //end of methods
  mounted() {
    var seo = document.getElementById("seo")

    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
    }

    document.title = "Contact American Credit | Call, Chat or Form Fill";
    meta.content =
      "Have questions about American Credit's small business loans? Give us a call, chat online or use our secure form. Our loan specialists are here to help you!";
    keywords.content = "american credit background, small business financing, american credit history, american credit";
  }
};
</script>

<style scoped lang="scss">
@import "../assets/css/global.scss";
@import "../assets/css/fonts.css";
.american-credit-thank-you-img {
  width: 468px !important;
  margin-left: 50px;
  margin-top: 70px !important;
}

.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.second_main {
  margin-top: 10px;
  width: 61.8%;
  align: center;
  margin-left: 300px;
  margin-right: 300px;
}

.second_title {
  padding: 3px 0px 15px 0px;
  color: #747474;
}

.second_main .el-form-item__label {
  text-align: center;
}

.second_main input {
  margin-left: 0;
}

.second_main .label_text .el-form-item__label {
  width: 14% !important;
}

.second_main .label_text .el-form-item__content {
  margin-left: 15% !important;
}

.select_width .el-input__icon + .el-input__inner {
  padding-right: 95px;
}

.Infosave {
  margin: 15px 0px;
}

@media screen and (max-width: 768px) {
  .american-credit-thank-you-img {
    width: 100% !important;
    margin-left: 0;
    margin-bottom: 20px;
    margin-top: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// thankYou.vue?7dbda6ac